import React, { useEffect, useState } from 'react'
import { Alert } from 'reactstrap';

const CAlert = ({ show, color = 'secondary', text = '', onClick = () => { }, timeout }) => {

    const [visible, setVisible] = useState(show || false);
    const onDismiss = () => setVisible(false);

    useEffect(() => {
        if (!show) return
        setVisible(show)

    }, [show])

    useEffect(() => {
        if (!timeout) return

        setTimeout(function () {
            onDismiss()
        }, 10000);

    }, [timeout])

    return visible ? <Alert
        className='text-center'
        color={color}
        isOpen={visible}
        toggle={onDismiss}
        fade
        onClick={onClick}
    >
        {text}
    </Alert> : null
}

export default CAlert;